/**
 * @file ProviderLogin.jsx
 * @description Handles third-party provider authentication (OAuth, SSO)
 *
 * @section Responsibilities
 * - Manage provider authentication flow
 * - Handle OAuth/SSO integration
 * - Process provider tokens
 * - Manage provider state
 * - Handle provider errors
 * - Provide provider status
 *
 * @section Dependencies
 * - OAuthService: OAuth authentication
 * - SSOService: SSO integration
 * - ProviderService: Provider management
 * - TokenService: Token handling
 *
 * @section Integration Points
 * - Provider APIs: Authentication endpoints
 * - OAuth System: OAuth flow
 * - SSO System: Single sign-on
 * - Token System: Provider tokens
 *
 * @section State Management
 * - providerState: Provider status
 * - authState: Authentication status
 * - tokenState: Token management
 * - errorState: Error handling
 *
 * @section Events
 * - onProviderSelect: Provider selection
 * - onAuth: Authentication handling
 * - onToken: Token processing
 * - onError: Error handling
 *
 * @section Props
 * @prop {Array} providers - Available providers
 * @prop {Function} onComplete - Completion callback
 * @prop {Object} providerConfig - Provider configuration
 * @prop {Boolean} autoRedirect - Controls automatic redirect
 */

import axios from "axios";
import Swal from "sweetalert2";

function ProviderLogin({ provider = "" }) {
  const getLoginUrl = () => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/user/auth?provider=${provider}&origin=${window.origin}`
      )
      .then((res) => {
        window.location.href = res.data.message;
      });
  };

  const devAlert = () => {
    Swal.fire({
      title: "Under Development",
      text: "Work in progress",
      icon: "warning",
    });
  };

  return (
    <img
      onClick={getLoginUrl}
      className="provider-logo"
      src={`./../../assets/${provider.toLowerCase()}_logo.png`}
    />
  );
}

export default ProviderLogin;
